import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Estado de Conservação',
  path: '/patrimonio/patestadoconservacao',
  name: 'patestadoconservacao',
  component: () => import('@/views/patrimonio/patestadoconservacao/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.ESTADODECONSERVACAONOVO_MENU_1200300299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Estado de Conservação',
  path: '/patrimonio/patestadoconservacao/cadastro/:id?',
  parent: 'patestadoconservacao',
  name: 'patestadoconservacao_create',
  component: () => import('@/views/patrimonio/patestadoconservacao/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.ESTADODECONSERVACAONOVO_MENU_1200300299],
  },
  goesToMenu: true,
 },
]
